var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconTwitter = function SvgIconTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    fillRule: "evenodd",
    d: "M9.25 12.629 1.037 2.178h6.506l5.072 6.46 5.417-6.431h3.584l-7.269 8.637 8.619 10.978h-6.488l-5.49-6.985-5.863 6.966H1.521l7.73-9.174Zm8.173 7.257L5.025 4.114h1.571l12.382 15.772h-1.555Z",
    clipRule: "evenodd"
  })));
};
export default SvgIconTwitter;